import { Button } from 'uikit';
import { getCheckedIdsArr } from 'utils';

import { useCallback, useMemo, useState } from 'react';

import { AgreementsAddTable } from '../AgreementsAddTable';
import { useAddRatioAgreements } from '../hooks/useAddRatioAgreements';
import { useAgreementTableAddRatio } from '../hooks/useAgreementTableAddRatio';

import { AgreementsRatioInfoTable } from './AgreementsRatioInfo';

interface IAgreementsAddRatioProps {
    refreshAgreementsRatio: () => void;
    refreshFilters: () => void;
    disabledByStatus: boolean;
    isDisabledByProjectStatus: boolean;
    isDisabledByContractStatus: boolean;
}

export const AgreementsAddRatio = ({
    refreshAgreementsRatio,
    refreshFilters,
    disabledByStatus,
    isDisabledByProjectStatus,
    isDisabledByContractStatus,
}: IAgreementsAddRatioProps) => {
    const [openModal, setOpenModal] = useState<boolean>(false);

    const {
        titleModal,
        searchPlaceholder,
        agreementId,
        checkedIds,
        setCheckedIds,
        searchString,
        setSearchString,
        agreementsData,
        agreementsStatus,
        agreementsErrors,
        finalColumns,
        isSubmittedDataTable,
        handleCloseErrorAgreementTable,
        handleSearch,
        handleChange,
        handleClearSearch,
        closeRatioInfoTable,
        ratioNameForInfo,
        dataSource,
    } = useAgreementTableAddRatio(openModal, disabledByStatus);

    const {
        titleAddError,
        addRatioAgreementsData,
        addRatioAgreementsStatus,
        addRatioAgreementsError,
        isSubmittedAddRatio,
        handleAddRatioAgreements,
        handleCloseErrorModalAddRatio,
        handleCreateReportAddRatio,
    } = useAddRatioAgreements(
        agreementId,
        checkedIds,
        setCheckedIds,
        refreshAgreementsRatio,
        setOpenModal,
        refreshFilters,
    );

    const handleOpenModal = useCallback(() => setOpenModal(true), []);
    const handleCloseModal = useCallback(() => {
        setCheckedIds({});
        setSearchString('');
        setOpenModal(false);
    }, [setCheckedIds, setSearchString]);

    const isConfirmDisabled = useMemo(() => !getCheckedIdsArr(checkedIds).length, [checkedIds]);

    return (
        <>
            <Button
                label="Добавить коэффициенты"
                size="s"
                view="secondary"
                onClick={handleOpenModal}
                disabled={disabledByStatus || isDisabledByProjectStatus || isDisabledByContractStatus}
            />
            {openModal && (
                <AgreementsAddTable
                    titleModal={titleModal}
                    handleCloseAddAgreements={handleCloseModal}
                    searchPlaceholder={searchPlaceholder}
                    searchString={searchString}
                    handleChange={handleChange}
                    handleSearch={handleSearch}
                    handleClearSearch={handleClearSearch}
                    tableColumns={finalColumns}
                    isSubmittedAddMtr={isSubmittedAddRatio}
                    addAgreementsStatus={addRatioAgreementsStatus}
                    addAgreementsData={addRatioAgreementsData}
                    addAgreementsError={addRatioAgreementsError}
                    handleAddAgreements={handleAddRatioAgreements}
                    handleCloseErrorModalAdd={handleCloseErrorModalAddRatio}
                    handleCreateReportAdd={handleCreateReportAddRatio}
                    titleAddError={titleAddError}
                    isSubmittedDataTable={isSubmittedDataTable}
                    agreementsStatus={agreementsStatus}
                    agreementsData={agreementsData}
                    agreementsErrors={agreementsErrors}
                    handleCloseErrorAgreementTable={handleCloseErrorAgreementTable}
                    dataSource={dataSource}
                    isConfirmDisabled={isConfirmDisabled}
                />
            )}
            {ratioNameForInfo && (
                <AgreementsRatioInfoTable ratioName={ratioNameForInfo} closeRatioInfoTable={closeRatioInfoTable} />
            )}
        </>
    );
};

AgreementsAddRatio.displayName = 'AgreementsAddRatio';
